import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import getIsProduction from '@/helpers/utils/getIsProduction';
const Stub = Promise.resolve(() => null);
const Debug_ = dynamic(() => !getIsProduction() && process.env.NODE_ENV !== 'test' ? import('./Debug') : Stub, {
  ssr: false
});
export default function Debug() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><Debug_ /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}